module.exports = __webpack_public_path__ + "img/infoC.e3a0538a.svg";